// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"8102ce7c","290":"968677e0","647":"c976329f","960":"89f4e3e8"}[chunkId] + ".chunk.js";
};